import axios from 'axios';
import { DOMAIN, DOMAINCLIENT } from "../Constant";

const instance = axios.create({
    baseURL: `${DOMAIN}/api`
});

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            window.dispatchEvent(new Event('sessionExpired'));
        }
        return Promise.reject(error);
    }
);

export default instance;